<div class="loading-container">
  <img src="/assets/images/loading.gif" />
</div>
